import PalletStockScreenComponent, {
    PalletStockScreenComponentProps,
} from './PalletStockScreenComponent';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import { iRootDispatch, iRootState } from '../../../store/store';
import { connect } from 'react-redux';
import { select } from '../../../store/store';
import { WarehouseStore } from '../../../store/models/WarehouseModel';

export type PalletStockScreenGridItemData = {
    id: string;
    totalAvailableProductUnitsSum: number;
    productName: string;
    totalLockedProductUnitsSum: number;

    attributeGroups: {
        attributeName: 'string';
        attributeType: number;
        //
        attributeWarehouseStocks: {
            attributeValue: 'string';
            warehouseStock: {
                warehouseId: 'string';
                availableUnits: number;
                lockedUnits: number;
                warehouseName: 'string';
            }[];
        }[];
    }[];
};

export type ProductCarrierItemData = {
    id?: string;
    carrierTypeId?: string;
    carrierStatus?: string;
    carrierStatusDescription?: string;
    isStackable?: boolean;
    layersCount?: number;
    maximumStackLayers?: number;
    stockStatusDescription?: string;
    supplierName?: string;
    carrierWarehouseStorageData?: {
        warehouseEntryDateTime?: Date;
        warehouseEntryDocumentId?: string;
        warehouseId?: string;
        warehouseName?: string;
    };
    productId?: string;
    productName?: string;
    productUnitsOnCarrier?: number;
    stockStatus?: string;
    //
    stockAttributes?: {
        attribute1: {
            name?: string;
            value?: string;
        };
        attribute2: {
            name?: string;
            value?: string;
        };
        attribute3: {
            name?: string;
            value?: string;
        };
        attribute4: {
            name?: string;
            value?: string;
        };
        attribute5: {
            name?: string;
            value?: string;
        };
        attribute6: {
            name?: string;
            value?: string;
        };
        attribute7: {
            name?: string;
            value?: string;
        };
        attribute8: {
            name?: string;
            value?: string;
        };
        attribute9: {
            name?: string;
            value?: string;
        };
        attribute0: {
            name?: string;
            value?: string;
        };
    };
};

export const ProductCarrierItemDataKeys = [
    'id',
    'carrierStatus',
    'carrierStatusDescription',
    'isStackable',
    'layersCount',
    'stockStatusDescription',
    'supplierName',
    'carrierWarehouseStorageData.warehouseEntryDateTime',
    'carrierWarehouseStorageData.warehouseEntryDocumentId',
    'carrierWarehouseStorageData.warehouseId',
    'carrierTypeId',
    'maximumStackLayers',
    'productId',
    'productName',
    'productUnitsOnCarrier',
    'stockStatus',
    'stockAttributes.attribute1.name',
    'stockAttributes.attribute1.value',
    'stockAttributes.attribute2.name',
    'stockAttributes.attribute2.value',
    'stockAttributes.attribute3.name',
    'stockAttributes.attribute3.value',
    'stockAttributes.attribute4.name',
    'stockAttributes.attribute4.value',
    'stockAttributes.attribute5.name',
    'stockAttributes.attribute5.value',
    'stockAttributes.attribute6.name',
    'stockAttributes.attribute6.value',
    'stockAttributes.attribute7.name',
    'stockAttributes.attribute7.value',
    'stockAttributes.attribute8.name',
    'stockAttributes.attribute8.value',
    'stockAttributes.attribute9.name',
    'stockAttributes.attribute9.value',
    'stockAttributes.attribute0.name',
    'stockAttributes.attribute0.value'
];

export type PalletStockScreenStateProps = {};

export interface PalletStockScreenDispatchProps {}

const selection = () => select((_models) => ({}));

const mapStateToProps = (
    state: iRootState,
    ownProps: PalletStockScreenComponentProps
): PalletStockScreenStateProps => ({
    createWarehousesDataSource: () => {
        let opts = {
            store: WarehouseStore,
            select: ProductCarrierItemDataKeys,
        } as DataSourceOptions;
        //
        return opts;
    },
    //
    ...selection()(state),
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: PalletStockScreenDispatchProps) =>
    ({
        ..._ownDispatch,
    } as PalletStockScreenDispatchProps);

export type connectedProps = PalletStockScreenStateProps & ReturnType<typeof mapDispatch>;
export type PalletStockScreenProps = connectedProps;

// @ts-ignore
export const PalletStockScreen = connect(
    mapStateToProps,
    mapDispatch as any
)(PalletStockScreenComponent as any);
